module.exports = __webpack_public_path__ + "static/media/onboarding-phones.es.68d7d9a2.png";